/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  global-require,
  import/no-extraneous-dependencies
*/
// needed for react intl otherwise stuff busts

import React from 'react';
import { FeatureFlagProvider } from 'hellospa/components/feature-flags';
import { isProduction } from 'hellospa/ts-utils';

import ReactDOM from 'react-dom';
import HSIntlProvider from 'hellospa/components/hs-intl-provider';
import useDiv from 'hellospa/common/hooks/use-div';
import Application from './detached-application';

require('intl');

module.exports = Application;

// All HelloSign components need to be attached to the application for legacy
// purposes.
Application.components = require('./components');


let first;
function useSingleton() {
  const state = React.useState(Math.random());
  first ??= state;
  return first === state;
}

function ShowPHPFlag() {
  const div = useDiv();
  const singleton = useSingleton();

  try {
    // I'm not sure if Safari might ever throw when trying to access
    // localStorage, so I'm using this try/catch to make sure this doesn't break
    // even if we can't access localStorage
    if (singleton && localStorage.showPHPFlag === 'true') {
      return ReactDOM.createPortal((
        <div
          title='This page uses React components in a PHP template'
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            backgroundColor: 'red',
            padding: '0.5em',
            zIndex: 9999,
          }}
        >
          PHP Template
        </div>
      ), div);
    }
  } catch (e) {
    // ignore
  }

  return null;
}

// I'm wrapping these here instead of inside ./components so that they only get
// the provider when called from PHP's render_react_components. If there is code
// somewhere in `hellosign-web` that imports components, it should already have
// a provider near the top of the tree.
Application.components = Object.keys(Application.components).reduce((componentMap, name) => {
  const Component = Application.components[name];

  // When using `render_react_component` on the backend, you need to pass
  // `featureFlags` if any component in the tree accesses feature flags.  If you
  // do not pass feature flags and something down the tree attempts to acccess
  // them, it will throw an error. This is because I believe it's better to
  // crash early and try to get developers to fix the problem instead of
  // allowing the user to have a feature flag, that works in some scenarios and
  // doesn't in others.
  const IntlComponent = ({ featureFlags = null, ...props }) => (
    <FeatureFlagProvider featureFlags={featureFlags}>
      <React.Suspense fallback={<React.Fragment />}>
        {!isProduction() && <ShowPHPFlag />}
        <HSIntlProvider>
          <Component {...props} />
        </HSIntlProvider>
      </React.Suspense>
    </FeatureFlagProvider>
  );

  IntlComponent.displayName = `Intl(${name})`;

  componentMap[name] = IntlComponent;
  return componentMap;
}, {});

Application.mixins = {
  AdjustScrollingMixin: require('./components/api-docs/api-menu/adjust-scrolling-mixin'),
};
